import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { TicketBatchTicket } from './ticket-batch-ticket';

export class TicketBatchTicketSpare extends BaseEntity {

  id                : number            ;
  ticketBatchTicket : TicketBatchTicket	;
  assetProduct      : AssetProduct      ;
  quantity          : number            ;

  constructor() {
    super();

  }
}

